import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  domains: {
    domain: [],
  },
  listToken: {},
};

const slice = createSlice({
  name: "tokenManagement",
  initialState,
  reducers: {
    //generate token
    generateToken(state, action) {},
    generateTokenSuccess(state, action) {
      state.token = action.payload;
    },
    getDomains(state, action) {},
    getDomainsSuccess(state, action) {
      state.domains = action.payload;
    },
    createToken(state, action) {},
    createTokenSuccess(state, action) {},
    getListToken(state, action) {},
    getListTokenSuccess(state, action) {
      state.listToken = action.payload;
    },

    updateToken(state, action) {},
    updateTokenSuccess(state, action) {},

    deleteToken(state, action) {},
    deleteTokenSuccess(state, action) {},
  },
});

export default slice.reducer;

export const {
  generateToken,
  generateTokenSuccess,
  getDomainsSuccess,
  getDomains,
  createToken,
  createTokenSuccess,
  getListToken,
  getListTokenSuccess,
  updateToken,
  updateTokenSuccess,
  deleteToken,
  deleteTokenSuccess,
} = slice.actions;
